import request from '@/utils/request'

export function login_with_sso(ticket) {
  return  request({
    url: '/api/admin/user/login_with_sso/',
    method: 'get',
    params: {ticket}
  })

}

export function getInfo(user_id) {
  return request({
    url: '/api/admin/user/' + user_id.toString() + '/',
    method: 'get',
  })
}

export function logout() {
  return request({
    url: '/api/admin/user/logout/',
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js